import React, { useState } from 'react';
import LinkType from '../../../constants/LinkType';
import { Resource } from '../../../models/Resources';
import useResourceService from '../../../services/ResourceService';
import AriaLink from '../../AriaLink/AriaLink';

interface Props {
  resource: Resource;
}

function extractFilename(filename: string | null): string {
  return filename?.replace('attachment; filename="', '').replace('"', '').trim() ?? 'Untitled';
}

const ResourceLink = ({ resource }: Props): JSX.Element => {
  const [error, setError] = useState<boolean>(false);
  const resourceService = useResourceService();

  const url = resource.link;

  const downloadAndOpenResource = async (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>): Promise<void> => {
    if (resource.type !== 'external') {
      event.preventDefault();
      try {
        await resourceService.getDocument(url).then((response) => {
          response.blob().then((blob) => {
            const filename: string = extractFilename(response.headers.get('content-disposition'));
            const link = document.createElement('a');
            link.target = '_blank';
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
          });
        });
      } catch (err) {
        setError(true);
      }
    }
  };

  if (error) {
    throw new Error('could not fetch document content');
  }

  return (
    <div className="icon-link" key={resource.title}>
      <li>
        {resource.type === 'external' ? (
          <AriaLink link={url} linkType={LinkType.DOCUMENT} customLinkText={resource.title} />
        ) : (
          <AriaLink
            link="#"
            linkType={LinkType.DOCUMENT}
            customLinkText={resource.title}
            customLabel={`Download ${resource.title}`}
            onClick={downloadAndOpenResource}
          />
        )}
      </li>
    </div>
  );
};

export default ResourceLink;
